import Stack from '@mui/material/Stack'

import { H3, P } from '@mxenabled/mxui'

import ProfileProgressBar from '../ProfileProgressBar'

interface OnboardingStepsHeaderProps {
  completeCopy: string
  primaryText: string
  secondaryText: string
  value: number
}

const OnboardingStepsHeader = ({
  completeCopy,
  primaryText,
  secondaryText,
  value,
}: OnboardingStepsHeaderProps) => {
  return (
    <Stack sx={{ gap: 20, p: 24 }}>
      <Stack sx={{ gap: 8 }}>
        <H3>{primaryText}</H3>
        <P variant="subtitle1">{secondaryText}</P>
      </Stack>
      <ProfileProgressBar completeCopy={completeCopy} value={value} />
    </Stack>
  )
}

export default OnboardingStepsHeader
